import { env } from "@/env";
import { createMagentoStoreHandler } from "@/libs/commerce/getMagentoStore/createMagentoStoreHandler";

export const getMagentoStoreHandler = (isTrial: boolean = false) => {
  const defaultStore = isTrial ? "trial" : "default";

  return createMagentoStoreHandler({
    defaultStore,
    modelName: isTrial ? "magento-locale-trial-store-map" : "magento-locale-store-map",
    mapPropertyName: isTrial ? "localeToTrialStoreMap" : "localeToStoreMap",
    ...(isTrial
      ? {}
      : {
          isStoreSupported: (store: string) => env.availableMagentoStores.split(",").includes(store),
          fallbackToLocale: true,
        }),
  });
};
